<h1 class="page-title">Gyülekezetünkről</h1>

<h2>Rólunk</h2>

<p>
  A Kaposvári Keresztény Közösség történelmi hitelveket valló, a Biblia tekintélyét elfogadó helyi gyülekezet.
  Tanításának középpontjában Jézus Krisztus személye áll.
</p>

<p>
  Közösségünk 1998-ban, keresztény családok kezdeményezésével alakult. Amit az elmúlt években láttunk és tapasztaltunk
  gyülekezetünk életében, az a legszebb reményeink beteljesedése volt. Ez a mindössze 10-12 fős csapat mára több, mint
  100 fős gyülekezetté növekedett.
</p>

<h2>Hitelveink</h2>

<p>
  Hiszünk egy teremtő, örökkévaló és személyes Istenben.
</p>

<p>
  Hiszünk abban, hogy minden ember bűnös és Isten megváltására van szüksége. Ez a megváltás Jézus Krisztus által történt
  meg, és minden ember megmenekülhet a benne való hit által.
</p>

<p class="quote scripture">
  <span class="text">"Mert úgy szerette Isten az embereket, hogy egyetlen Fiát (Jézust) adta, hogy aki hisz a Fiúban, el ne vesszen, hanem
    örök élete legyen."</span>
  <span class="location">János evangéliuma 3. rész 16. vers</span>
</p>

<p>
  Hiszünk a menny és a pokol valóságában, a feltámadásban, és abban, hogy Isten meg fog ítélni minden embert.
</p>

<p>
  Hiszünk abban, hogy Jézus Krisztus egyházába minden Őbenne hívő beletartozik. A helyi gyülekezeti közösségek azok a
  helyek, ahol a hívők növekszenek a személyes hitükben és az egymással való szeretet kapcsolatban.
</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/who-we-are/about-us/about-us.component.html